export default {
    "helloVisitor": "Olá, Visitante",
    "hello": "Olá, {name}",
    "points": "pontos",
    "loginButton": "Fazer Login",
    "rewardsTitle": "Recompensas",
    "rewardsSubtitle": "Troque seus pontos por recompensas",
    "rewardsEmpty": "Nenhuma recompensa disponível no momento.",
    "activeCoupons": "Cupons ativos",
    "couponAvailable": "Disponível",
    "couponValidUntil": "Válido até {date}",
    "copyCode": "Copiar código",
    "codeCopied": "Código copiado!",
    "rewardUnavailable": "Indisponível",
    "rewardPoints": "{points} pontos",
    "rewardRedeemed": "Resgatada",
    "rewardExclusive": "Recompensa exclusiva para clientes",
    "missingPoints": "Faltam {points} pontos",
    "missingOnePoint": "Falta 1 ponto",
    "useNow": "Utilizar agora",
    "redeemTitle": "Trocar {points} pontos por \"{name}\"?",
    "redeemMessage": "Isso vai reduzir o seu saldo em {points} pontos.",
    "redeemConfirm": "Confirmar",
    "redeemCancel": "Cancelar",
    "redeemClose": "Fechar",
    "redeemSuccessTitle": "Recompensa resgatada!",
    "redeemSuccessMessage": "Recompensa resgatada com sucesso. Consulte o estabelecimento para utilizá-la.",
    "redeemSuccessHome": "Tela inicial",
    "redeemError": "Não foi possível resgatar agora, tente novamente.",
    "redeemErrorPointsProgramInactive": "O programa de pontos não está disponível no momento.",
    "redeemErrorStaffOnly": "Esta recompensa só pode ser resgatada no estabelecimento.",
    "redeemErrorRewardUnavailable": "Esta recompensa não está mais disponível.",
    "redeemErrorRecentRedemption": "Você acabou de resgatar esta recompensa, aguarde 1 minuto e tente novamente.",
    "redeemErrorInsufficientPoints": "Você não tem pontos suficientes.",
    "yourPoints": "Seus pontos:",
    "loginToSeePoints": "Faça login para ver seus pontos",
    "howToUse": "Como usar essa recompensa?",
    "back": "Voltar",
    "redeemReward": "Resgatar recompensa",
    "insufficientPoints": "Pontos Insuficientes",
    "loginToRedeem": "Fazer login para resgatar",
    "confirmRedeemTitle": "Deseja resgatar?",
    "redeemStaffTitle": "Como resgatar",
    "balanceAfter": "Seu saldo após troca:",
    "faqTitle": "Dúvidas Frequentes",
    "faqOthers": "Outras Dúvidas",
    "faqSearch": "Buscar",
    "faqEmpty": "Nenhuma dúvida cadastrada ainda.",
    "faqNoResults": "Nenhuma dúvida encontrada para essa busca.",
    "bannerSlide": "Banner {index} de {total}",
    "modalClose": "Fechar",
    "termsTitle": "Termos de uso",
    "termsAccept": "Li e concordo com os termos de uso",
    "termsEmpty": "Nenhum termo de uso cadastrado ainda.",
    "statementTitle": "Extrato",
    "statementBalance": "Saldo de Pontos:",
    "statementEmpty": "Nenhuma movimentação por aqui ainda.",
    "statementDateLine": "{date} às {time} - {weekday}",
    "statementReceived": "Recebeu {points} pontos!",
    "statementReceivedOne": "Recebeu 1 ponto!",
    "statementUsed": "Usou {points} pontos!",
    "statementUsedOne": "Usou 1 ponto!",
    "statementReward": "Recompensa: {name}",
    "statementPurchase": "Compra feita {date}",
    "statementAddedBy": "Pontos adicionados por: {name}",
    "statementAdded": "Pontos adicionados",
    "statementExpand": "Expandir extrato",
    "statementCollapse": "Recolher extrato",
    "menuStatement": "Extrato",
    "menuFaq": "Perguntas frequentes",
    "menuTerms": "Termos de uso",
    "menuRules": "Regras",
    "rulesTitle": "Regras do programa",
    "menuLogout": "Sair",
    "tabPoints": "Pontos",
    "tabCashback": "Cashback",
    "tabReferral": "Indicação",
    "comingSoon": "Em breve"
};
